export default {"src":"/_next/static/media/ChevronUp.c0e5880c.svg","height":24,"width":24};